'use strict';
import gsap from "gsap";
import {Draggable} from "gsap/Draggable";
import {CardTypes} from '../../common';
import {
    cardsData,
    isDesktop,
    isMobile,
    projectMode,
    settingsData,
    threeJsVariables,
    TRoot,
    UIRoot
} from "../../settings";
import {
    openOptionsCard,
    removeOptionsCardGallery,
    resizeOptionsCardGallery,
} from './optionsCards';
import {selectionBoxesSetStatusColor} from "../threejs/raycast";
import {
    isCompareMode,
    lockScreenOrientation,
    moveCameraToBuildingInCylinder,
    setCSSVar,
    userPrevent
} from '../../functions';
import {findSelectionAndCrmData, rotation_to_flat} from "../../functions";
import {setActiveClassHandler} from "./unitCards/unitCardFunctions";
import {UnitCardClass} from "./unitCards/UnitCardClass";
import { getCurrentLangDirection} from '../components/langSwitcher/langSwitcher';
import { updateCompareButtonOffset, updateCompareButtonOffsetWeb } from '../menu/navigation/compareButton';
import { Vantages } from '../components/vantage/Vantage';
import {GetElement} from "../interfaces/GetElement";
import { BmbyMode } from '../mode/BmbyMode';
import {renderUpdateValuesOnDemand} from "../../app";
import {getActiveMenuData} from "../menu/menu";
import { closeNotifications } from '../analytics/statistic';

export const createUnitCardAnimation = (object) => {
    const cardBox = UnitCardClass.findCard(object.engineId)?.html;
    const directionHtml = document.documentElement.getAttribute('dir');
    const menu = document.querySelector('.aside__container');
    const menuPosition = menu ? menu.getAttribute('data-menu-position') : 'right';

    let direction = (menuPosition === 'right') ? 'left' : 'right';

    if (BmbyMode.active) {
        direction = directionHtml === 'rtl' ? 'left' : 'right';
    }

    const navBar = document.querySelector('.right-nav-bar');

    const winY = threeJsVariables.mouse.winY;
    const winX = threeJsVariables.mouse.winX;

    const offsetWidth = directionHtml === 'rtl' ? 32 : 37;
    let position = offsetWidth;
    let scale = 1;
    let top = 110;
    let directionValue = 20;

    if (settingsData.buildingDestroyed)
        position = navBar.clientWidth + offsetWidth * 2;

    if (isDesktop) {
        direction = 'right';
        position = document.querySelector(`.search__container-main`).getBoundingClientRect().width + 80;
        directionValue = position;
        scale = 1.3;
        top = 200;
    } else {
        position = UnitCardClass.findCard(false, 'non-active')?.html ? position + 20 : position
    }


    const tl = gsap;
    if (UnitCardClass.cards.length > 1) {
        UnitCardClass.cards[1].html.style.top = 'unset';
        const cardMaxHeight = Math.max(...UnitCardClass.cards.map(card => card.html.getBoundingClientRect().height));
        const totalHeight = cardMaxHeight * 2;
        let offset = 75;
        let navBarHeight = 0;

        if (!isDesktop) {
            scale = 0.85;
            position = 75;
            offset = 50;
            const floorSlider = document.querySelector('.fs__main__container')?.getBoundingClientRect().width + 15 || 0;
            directionValue = directionValue + floorSlider;
            updateCompareButtonOffsetWeb(directionValue);
        } else {
            navBarHeight = document.querySelector('.bottom__nav-bar').getBoundingClientRect().height + 80;
            updateCompareButtonOffset(navBarHeight / 2);
        }

        if (totalHeight > window.innerHeight) {
            scale = window.innerHeight / (totalHeight + offset);
            position = (window.innerHeight - totalHeight + offset) / 2;
        } else {
            position = (window.innerHeight - totalHeight) / 2;
            navBarHeight = 0;
            updateCompareButtonOffset(0);
        }

        gsap.fromTo(
          [UnitCardClass.cards[0].html, UnitCardClass.cards[1].html],
          {scale: 1},
          {
              scale: scale,
              [direction]: directionValue,
              onStart: () => {
                  userPrevent(true);
              },
              onComplete: () => {
                  setTimeout(() => {
                      userPrevent(false);
                  }, 100);
              }
          });
            gsap.set(UnitCardClass.cards[0].html, {bottom: 'unset'});
            gsap.to(UnitCardClass.cards[0].html, {top: position});
            gsap.set(UnitCardClass.cards[1].html, {top: 'unset'});
            gsap.to(UnitCardClass.cards[1].html, {bottom: position + navBarHeight});
    } else {
        tl.from(cardBox, {
            top: winY,
            [direction]: winX,
            scale: 0,
        })
        tl.to(cardBox, {
            duration: 1.8,
            [direction]: position,
            scale: scale,
            ease: "expo.out",
            top: top,
            onStart: () => {
                userPrevent(true);
                settingsData.bombBlock = true;
            },
            onComplete: () => {
                userPrevent(false);
                if (!isDesktop) {
                    const currentOpenedCard = UnitCardClass.findCard();
                    if (currentOpenedCard)
                        currentOpenedCard.html.style.removeProperty('transform');
                }
                settingsData.bombBlock = false;
            }
        });
    }

}

export const dragUnitCard = () => {
    gsap.registerPlugin(Draggable);

    const cardBox = document.querySelectorAll(`.${CardTypes.Unit}-card`);
    if (!cardBox)
        return;

    // const menu = document.querySelector('.aside__container');
    // const menuWidth = menu ? menu.offsetWidth : 0;
    const buttonsHeight = document.querySelector('.bottom__nav-bar').getBoundingClientRect().height;
    const rtl = document.documentElement.getAttribute('dir') === 'rtl';
    const TRootWidth = TRoot.getBoundingClientRect().width;
    const UIRootWidth = UIRoot.getBoundingClientRect().width;
    const searchWidth = UIRoot.querySelector('.search__container-main')?.getBoundingClientRect().width || 0;

    const desktopModeBounce = {
        top: 0,
        left: -TRootWidth,
        width: window.innerWidth - searchWidth,
        height:window.innerHeight - (buttonsHeight + 80)
    };
    const webModeBounce = {
        top: 0,
        left: rtl ? - (window.innerWidth - UIRootWidth) : UIRootWidth,
        width: window.innerWidth - UIRootWidth,
        height: window.innerHeight
    };

		Draggable.create([...cardBox], {
				type: "x,y",
				edgeResistance: 1,
				bounds: isDesktop ? desktopModeBounce : webModeBounce,
				inertia: true,
				zIndexBoost: false,
				onDragStart: (cardBox) => {
					cardsData.multiplyCards && setActiveClassHandler(cardBox);
				},
			}
		);
}

export const openOptionsCardAnimation = (params) => {
    let width = '', height = '';

    if (!isMobile && !isDesktop && !isCompareMode()) {
        width = 'calc(100% - 56px)';
        height = '100%';
    } else if (isDesktop) {
        width = '100%';
        height = '100%';
    }

    if (params?.disableAnimation) {
        if (!isMobile) {
            Vantages.scopes.forEach(scope => scope.viewer.calculateViewport());
        }
        return;
    }


    if (isMobile) {
        const popUpPageAnimationDelay = 0;
        const globalAnimationDelay = isMobile ? 0 : 0.3;
        const elementToAnimate = getElementToAnimate();
        if (isMobile)
            settingsData.animationsDuration = 1;

        gsap.fromTo(
            elementToAnimate,
            {bottom: '-100vh'},
            {
                delay: popUpPageAnimationDelay + globalAnimationDelay,
                bottom: 0,
                duration: settingsData.animationsDuration,
                onComplete: () => {
                    elementToAnimate.style.removeProperty('transform');
                    const vantageViewer = document.querySelector('.vantage-viewer');
                    !vantageViewer && renderUpdateValuesOnDemand(true);
                    const spoiler = document.querySelector(`.${CardTypes.Options}-card__spoiler`);
                    if (spoiler)
                        spoiler.classList.remove('hidden');
                }
            },
        );
    } else {
        gsap.fromTo(
          getElementToAnimate(),
          {
              width:1,
              height: 1,
              scale: 0,
              borderRadius: "50%"},
          {
              scale: 1,
              width: width,
              height: height,
              borderRadius: "0%",
              duration: settingsData.animationsDuration,
              onUpdate: () => Vantages.scopes.forEach(scope => scope.viewer.calculateViewport())
          }
        );
    }
}

export const closeOptionsCardAnimation = () => {
    const optionsCard =
      document.querySelector(`.${CardTypes.Options}-card`)
      || document.querySelector(`.${CardTypes.Options}-card .${CardTypes.Amenities}-card`);
    if (!optionsCard)
        return;

    if (isMobile) {
        const popUpPageAnimationDelay = 0;
        const globalAnimationDelay = isMobile ? 0 : 0.3;
        const elementToAnimate = getElementToAnimate();
        if (isMobile)
            settingsData.animationsDuration = 1;

        gsap.fromTo(
            elementToAnimate,
            {bottom: 0},
            {
                delay: popUpPageAnimationDelay + globalAnimationDelay,
                bottom: '-100vh',
                duration: settingsData.animationsDuration,
                onStart: () => {
                    const spoiler = document.querySelector(`.${CardTypes.Options}-card__spoiler`);
                    if (spoiler)
                        spoiler.classList.add('hidden');
                },
                onComplete: () => {
                    onCompleteCallbackFunction();
                }
            },
        );
    } else {
        gsap.fromTo(
          getElementToAnimate(),
          {
              scale: 1,
              borderRadius: "0%"
          },
          {
              scale: 0,
              borderRadius: "50%",
              duration: settingsData.animationsDuration,
              onComplete: onCompleteCallbackFunction
          }
        );
    }

    function onCompleteCallbackFunction() {
        optionsCard.remove();
        removeOptionsCardGallery();
        closeNotifications();
        // toggleCardMainButton();
        projectMode.Pagination.paginate({source: 'flatCloseButtonHandler'});
    }
}

const getElementToAnimate = () => {
    const optionsCards =
      document.querySelectorAll(`.${CardTypes.Options}-card`) ||
      document.querySelector(`.${CardTypes.Options}-card .${CardTypes.Amenities}-card`);
    // const plansBox = optionsCards[optionsCards.length - 1].querySelector('.options-card__plans-box');

    return optionsCards[optionsCards.length - 1];
}

/**
 *  Mobile animations
 */

export const unitCardOpenAnimation = async () => {
    // let direction;
    let depth;
    if (isMobile) {
        // settingsData.isLandscape
        //   ? direction = 'scaleY'
        //   : direction = 'scaleX';
        settingsData.isLandscape
          ? depth = -500
          : depth = -300;

        const currentCard = document.querySelector('.unit-card');
        gsap.fromTo(
          currentCard,
          {
              // [direction]: 5,
              // filter: 'blur(10px)',
              bottom: depth,
              duration: settingsData.animationsDuration
          },
          {
              // [direction]: 1,
              // filter: 'blur(0px)',
              bottom: 0,
              duration: settingsData.animationsDuration,
              onComplete: () => {
                  currentCard.removeAttribute('style');
              }
          }
        );
    }
}

export const closeUnitCardAnimation = async (currentCard, action) => {
    if (!currentCard)
        return;

    let depth;
    if (isMobile) {
        settingsData.isLandscape
            ? depth = -500
            : depth = -300;
        return new Promise(resolve => {
            gsap.to(
              currentCard,
              {
                  bottom: depth,
                  duration: settingsData.animationsDuration,
                  onComplete: () => {
                      if (action !== 'update')
                          removeUnitCard(currentCard, action);
                      // IntersectionLegenda.updatePosition();
                      resolve(true);
                  }
              },
            );
        });
    } else {
        return new Promise(resolve => {
            gsap.to(
              currentCard,
              {
                  scaleY: 0,
                  duration: settingsData.animationsDuration,
                  onStart: () => {
                      for (let child of currentCard.children) {
                          child.classList.add('hidden');
                      }
                  },
                  onComplete: () => {
                      if (action !== 'update')
                          removeUnitCard(currentCard, action);
                      currentCard.style.removeProperty('transform');
                      resolve(true);
                  }
              },
            );
        });
    }
}

const removeUnitCard = (currentCard, action) => {
    currentCard.remove();
    const unitCard = UnitCardClass.findCard()?.html;

    if (unitCard && unitCard.classList.contains('card-from-another-building')) {
        restorePreviouslyUnitCardPosition();
        return;
    }

    if (unitCard && action !== 'close-all') {
        const keyPlanButton = document.querySelector(`.${CardTypes.Unit}-card__button-key-plan`);
        const engineId = unitCard.getAttribute('data-engineid');
        const {selectedMesh} = findSelectionAndCrmData(engineId);
        if (!selectedMesh)
            return;
        cardsData.cardMode.isDoubleCard = true;
        selectedMesh.userData.isClicked = true;

        if (settingsData.buildingDestroyed && keyPlanButton) {
            keyPlanButton.click();
        } else {
            if (config.features.privateHouseMode) {
                moveCameraToBuildingInCylinder(engineId.split('_')[0]);
            } else {
                rotation_to_flat(selectedMesh);
                selectionBoxesSetStatusColor(selectedMesh, 'click');
            }
        }

        setTimeout(() => {
            cardsData.cardMode.isDoubleCard = false;
        }, 300);

        unitCard.classList.remove('non-active');

        if (cardsData.multiplyCards)
            unitCard.classList.add('active');
    }
    restorePreviouslyUnitCardPosition();
};


export function restorePreviouslyUnitCardPosition () {
    if (isMobile)
        return;

    if (UnitCardClass.cards.length > 0) {
        if (!settingsData.buildingDestroyed)
            UnitCardClass.cards.forEach(card => { card.html.classList.remove('unit-card--small') });

        const card = UnitCardClass.findCard().html;
        let position, value, direction,scale,directionValue, top;
        const height = card.getBoundingClientRect().height;
        const floorSlider = document.querySelector('.fs__main__container')?.getBoundingClientRect().width + 15 || 0;
        let offset = Math.round((height / card.offsetHeight + Number.EPSILON) * 100) / 100;

        if (isDesktop) {
            const search = document.querySelector(`.search__container-main`).getBoundingClientRect().width + 80;
            position = card.style.bottom === 'unset' ? 'top' : 'bottom';
            offset = offset === 1.3 ? 1 : offset;
            value = position === 'top' ? 200 : (window.innerHeight - 200 - height) * offset;
            direction = 'right';
            directionValue = search + floorSlider;
            scale = 1.3;
            top = '200px';
        } else {
            position = card.style.bottom === 'unset' ? 'top' : 'bottom';
            value = position === 'top' ? 110 : (window.innerHeight - 110 - height) * offset;
            directionValue = 37 + floorSlider;
            direction = getCurrentLangDirection() === 'ltr' ? 'right' : 'left';
            scale = 1;
            top = '110px';
        }

        gsap.to(card,{
            [position]: value,
            [direction]: directionValue,
            transform: `translate3d(0px, 0px, 0px) scale(${scale}, ${scale})`,
            duration: 0.5,
            onComplete: () => {
                isDesktop
                    ? card.style.bottom = ''
                    : card.style[position] = '';
                card.style.top = top ;
            }
        });
    }
}

// options card
export const openAndCloseMobileOptionsCard = (e, object = settingsData.lastClickedFlat.userData.crm_data, settings = config) => {
    const unitCard = UnitCardClass.findCard().html;
    const unitCardPreview = unitCard.querySelector(`.${CardTypes.Unit}-card__preview-block`);
    const unitCardWrapper = unitCard.querySelector(`.${CardTypes.Unit}-card__wrapper`);
    const shareBtn = unitCard.querySelector('.social-media-btn');
    const elementsToAnimate = [unitCardPreview, unitCardWrapper];

    if (shareBtn)
        elementsToAnimate.push(shareBtn);

    const tl = gsap.timeline();
    tl.to(elementsToAnimate, {
        duration: .2,
        opacity: 0,
    })
    tl.to(unitCard, {
        height: '100%',
        width: settingsData.isLandscape ? '100%' : '92vw',
        duration: .2,
        onUpdate: () => {
            unitCard.style.backgroundColor = 'var(--screenBg)';
            unitCard.style.width = '100%'
        },
        onComplete: () => {
            setTimeout(() =>  unitCard.style.backgroundColor = 'var(--menuBg)', 500 );

            if (settingsData.isLandscape) {
                openOptionsCard( {object, settings} );
                unitCardWrapper.removeAttribute('style');
                if (shareBtn)
                    shareBtn.removeAttribute('style');
                unitCard.style.width = '276px';
            }
        }
    })
    !settingsData.isLandscape && tl.to(unitCard, {
        width: '100%',
        duration: .2,
        onComplete: () => {
            openOptionsCard( {object, settings} );
            unitCardWrapper.removeAttribute('style');
            unitCardPreview.removeAttribute('style');
            shareBtn && shareBtn.removeAttribute('style');
            unitCard.removeAttribute('style');
        },
    })
}

export const fixedElementsPositionDurScrolling = () => {
    const scrollPlug = document.querySelector(`.${CardTypes.Options}-card__scroll-plug`);
    const optionsCard = document.querySelector(`.${CardTypes.Options}-card`);
    const header = document.querySelector(`.${CardTypes.Options}-card__header`);
    const optionsParameters = scrollPlug ? scrollPlug.getBoundingClientRect() : 0;
    const previewBlockParameters = document.querySelector(`.${CardTypes.Options}-card__plans-box`).getBoundingClientRect();
    const currentDirection = document.documentElement.getAttribute('dir');
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    const padding = currentDirection === 'rtl' ? '0 16px 3px 20px' : '0 20px 3px 16px';

    optionsCard.addEventListener('scroll', function scroll(e) {
        e.preventDefault();

        if (scrollPlug)
            scrollPlug.removeAttribute('style')

        if (optionsCard.scrollTop > previewBlockParameters.height - optionsParameters.height) {
            header.style.position = 'fixed';
            header.style.backgroundColor = '#151515';
            header.style.top = '57px';
            header.style.width = '100%';
            header.style.zIndex = '6';
            header.style.left = '0';
            header.style.padding = !isSafari ? padding : '0 16px 3px 16px';
            document.querySelector(`.${CardTypes.Options}-card__info-points`).style.marginTop = '95px';
        } else {
            header.removeAttribute('style');
            const infoPointsElement = document.querySelector(`.${CardTypes.Options}-card__info-points`);
            if (infoPointsElement)
                infoPointsElement.removeAttribute('style');
        }
    });
}

export const draggableOptionsCardBlock = (e, action) => {
    if (isCompareMode())
        return;

    const optionsCard = document.querySelector(`.${CardTypes.Options}-card`);
    const optionsCardData = document.querySelector(`.${CardTypes.Options}-card__data`);

    const stopAnimation = checkClick(e);
    if (stopAnimation) return;
    const isClose = optionsCardData.classList.contains('close-data');

    if (!action)
        action = isClose ? 'open' : 'close';

    let gridLayout;
    switch (action) {
        case ('open'):
            gridLayout = isDesktop
              ? `1fr 420px`
              : `420px 1fr`;
            break;
        case ('close'):
            gridLayout = isDesktop
              ? `1fr 130px`
              : `130px 1fr`;
            break;
    }

    if (isMobile || !optionsCard)
        return;

    const amenities = optionsCard.querySelector('.options-card__amenities');
    gsap.to(optionsCard, {
        gridTemplateColumns: gridLayout,
        duration: 0.5,
        onStart: () => {
            action === "open" ? optionsCardData.classList.remove('close-data') : optionsCardData.classList.add('close-data');

            if (amenities && action === "close")
                amenities.classList.add('hidden');
        },
        onUpdate: () => {
            resizeOptionsCardGallery();

            setCSSVar(
                '--optionsCardPlansBoxWidth',
                `${Math.round(new GetElement('.options-card__plans-box').width)}px`
            );
        },
        onComplete: () => {
            if (amenities && action === "open")
                amenities.classList.remove('hidden');
        }
    });
}

const checkClick = (e) => {
    const applyNowBtn = e.target === document.querySelector(`.${CardTypes.Options}-card__apply-now-btn`);
    const buyNow = e.target === document.querySelector(`.${CardTypes.Options}-card__buy-now_conf`);
    const similarAppChildEl = e.target.closest(`.${CardTypes.Similar}-card__container`);
    const favorite = e.target.closest(`.${CardTypes.Options}-card__favorite`);
    const switchers = e.target.closest(`.${CardTypes.Similar}-switcher-block`);

    return Boolean(favorite || switchers || similarAppChildEl || applyNowBtn || buyNow);
}

/**
 * COMPARE CARDS ANIMATION
 */

// export const rollUpAndExpandCompareCards = (e) => {
//     if (isCompareMode())
//         return;
//
//     const clickedCard = e.target.closest('.compare-block__card');
//
//     const compareCardList = document.querySelectorAll('.compare-block__card');
//     compareCardList.forEach(elem => {
//         const elemId = elem.getAttribute('data-engineid');
//         if (elemId && elemId !== clickedCard?.getAttribute('data-engineid'))
//             elem.classList.toggle('minimized');
//
//         clickedCard?.classList.remove('minimized');
//     })
// }

